// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { providerMessageSaga } from '../reducers/app';

import { t } from '../locales/i18n';
import { mapValidUntil, parseISO } from '../utils/date-utils';
import { InputWrapper } from './forms/input-wrapper';
import { Segment } from './segment';
import { HeroContainer, HeroHeader, HeroFooter, AppContent } from './layout/layout-components';
import { ProviderMessage as ProviderMessageType } from '../types/provider-message';
import { Button, Input, Dropdown } from 'semantic-ui-react';

import { RootState } from '../root-reducer';

const getValidUntilOptions = () => [
  {
    key: 'never',
    value: 'never',
    text: t('validUntil.neverShow')
  },
  {
    key: 'today',
    value: 'today',
    text: t('validUntil.today')
  },
  {
    key: 'tomorrow',
    value: 'tomorrow',
    text: t('validUntil.tomorrow')
  },
  {
    key: 'forever',
    value: 'forever',
    text: t('validUntil.forever')
  }
];

const initialState: ProviderMessageType & { formChanged: boolean } = {
  formChanged: false,
  // A dropdown key, like every other value this field takes.
  validTo: 'forever',
  message: ''
};

export interface ProviderMessageProps {
  providerMessage: ProviderMessageType | null;
  saveProviderMessage: (messageObj: ProviderMessageType) => void;
}

export class $ProviderMessage extends React.Component<ProviderMessageProps> {
  state = initialState;

  componentWillMount() {
    const { providerMessage } = this.props;
    const validTo = mapValidUntil(parseISO(providerMessage.validTo)).key;
    this.setState({
      message: providerMessage.message,
      validTo: validTo
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.formChanged) {
      return;
    }
    const { providerMessage } = nextProps;
    const validTo = mapValidUntil(parseISO(providerMessage.validTo)).key;
    this.setState({
      message: providerMessage.message,
      validTo: validTo
    });
  }

  render() {
    const { props, state } = this;
    const isValid = state.message && state.message.trim() !== '';
    return (
      <HeroContainer>
        <HeroHeader>
          <h1>{t('providerMessage.header')}</h1>
        </HeroHeader>
        <AppContent>
          <Segment>
            <InputWrapper label={t('providerMessage.textLabel')}>
              <Input
                value={state.message}
                onChange={(event) => this.setState({ message: event.target.value, formChanged: true })}
              />
            </InputWrapper>
            <InputWrapper label={t('validUntil.title')}>
              <Dropdown
                selection
                options={getValidUntilOptions()}
                label={t('')}
                value={state.validTo}
                onChange={(event, { value }) => this.setState({ validTo: value, formChanged: true })}
              />
            </InputWrapper>
          </Segment>
        </AppContent>
        <HeroFooter>
          <Button
            disabled={!isValid}
            onClick={() => props.saveProviderMessage({ validTo: state.validTo, message: state.message })}
            primary
          >
            {t('button.save')}
          </Button>
        </HeroFooter>
      </HeroContainer>
    );
  }
}

function mapStateToProps(state: RootState) {
  return {
    providerMessage: state.app.providerMessage || initialState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveProviderMessage: (message) => dispatch(providerMessageSaga(message))
  };
}

export const ProviderMessage = connect(mapStateToProps, mapDispatchToProps)($ProviderMessage);
